// /* eslint-disable jsx-a11y/anchor-is-valid */
// import React from 'react'

// type Props = {
//   className: string
//   data?: any
//   header?: any
//   hideHeader?: boolean
// }

// const TablesWidget14: React.FC<Props> = ({
//   className,
//   header = [],
//   data = [],
//   hideHeader = false,
// }) => {
//   return (
//     <div className={`card ${className}`}>
//       {(!hideHeader && (
//         <div className='card-header border-0 pt-5'>
//           <h3 className='card-title align-items-start flex-column'>
//             <span className='card-label fw-bold fs-3 mb-1'>Recent Sale</span>
//             <span className='text-dark mt-1 fw-semibold fs-7'>Last 10 supply</span>
//           </h3>
//         </div>
//       )) ||
//         ''}
//       <div className='card-body py-3'>
//         <div className='table-responsive'>
//           <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
//             <thead>
//               <tr className='fw-bold text-dark'>
//                 {header.length ? (
//                   header.map((eachHeader, eachInd) => (
//                     <th key={eachInd + 1 + ''}>{eachHeader.label}</th>
//                   ))
//                 ) : (
//                   <>
//                     <th className='min-w-150px'>Order ID</th>
//                     <th className='min-w-140px'>Factory Name</th>
//                     <th className='min-w-120px'>Date</th>
//                     <th className='min-w-120px'>Waste Collector</th>
//                     <th className='min-w-120px'>Material</th>
//                     <th className='min-w-100px'>Quantity</th>
//                   </>
//                 )}
//               </tr>
//             </thead>
//             <tbody>
//               {data.map((eachData, ind) => (
//                 <tr key={ind}>
//                   {header.map(({value}, index) => (
//                     <td key={index}>
//                       <a
//                         href='#'
//                         className={`${index === 0 ? 'ps-4 min-w-35px' : ''} ${
//                           value === 'quantity'
//                             ? 'badge badge-success fs-8 fw-semibold'
//                             : ' text-dark fw-bold text-hover-primary d-block mb-1 fs-6'
//                         }`}
//                       >
//                         {value === 'S.N'
//                           ? ind + 1
//                           : typeof eachData?.[value] === 'number'
//                           ? eachData?.[value]?.toFixed()
//                           : eachData?.[value]}
//                       </a>
//                     </td>
//                   ))}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   )
// }

// export {TablesWidget14}




/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
type Props = {
  className: string
  data?: any
  header?: any
  hideHeader?: boolean
}
const TablesWidget14: React.FC<Props> = ({
  className,
  header = [],
  data = [],
  hideHeader = false,
}) => {
  // Function to format date
  const formatDate = (dateString: string) => {
    if (!dateString) return dateString
    return dateString.split('T')[0] // Extract only the date part
  }

  // Function to check if value is a date
  const isDateField = (value: string) => {
    return value && typeof value === 'string' && value.includes('T') && value.includes(':')
  }

  return (
    <div className={`card ${className}`}>
      {(!hideHeader && (
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Recent Sale</span>
            <span className='text-dark mt-1 fw-semibold fs-7'>Last 10 supply</span>
          </h3>
        </div>
      )) ||
        ''}
      <div className='card-body py-3'>
        <div className='table-responsive'>
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bold text-dark'>
                {header.length ? (
                  header.map((eachHeader, eachInd) => (
                    <th key={eachInd + 1 + ''}>{eachHeader.label}</th>
                  ))
                ) : (
                  <>
                    <th className='min-w-150px'>Order ID</th>
                    <th className='min-w-140px'>Factory Name</th>
                    <th className='min-w-120px'>Date</th>
                    <th className='min-w-120px'>Waste Collector</th>
                    <th className='min-w-120px'>Material</th>
                    <th className='min-w-100px'>Quantity</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {data.map((eachData, ind) => (
                <tr key={ind}>
                  {header.map(({ value }, index) => {
                    const cellValue = value === 'S.N'
                      ? ind + 1
                      : typeof eachData?.[value] === 'number'
                        ? eachData?.[value]?.toFixed()
                        : isDateField(eachData?.[value])
                          ? formatDate(eachData?.[value])
                          : eachData?.[value]

                    return (
                      <td key={index}>
                        <span
                          className={`${index === 0 ? 'ps-4 min-w-35px' : ''} ${value === 'quantity'
                            ? 'badge bg-gray-300 text-dark fs-8'
                            : 'text-dark d-block mb-1 fs-6'
                            }`}
                        >
                          {cellValue}
                        </span>
                      </td>
                    )
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
export { TablesWidget14 }